import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import {
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoProductDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("no-product-detail-found-title", "Product not found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "no-product-detail-found-description",
          "The product you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() =>
          navigate(localizedPath("/products", language, defaultLang))
        }
      >
        {t("no-product-detail-found-back-button", "Back to Product List")}
      </Button>
    </Box>
  );
};

export default NoProductDetailFound;
